'use client';
/** @jsxImportSource @emotion/react */

import type { ListItemButtonProps } from '@mui/material/ListItemButton';

import MuiListItemButton, {
  listItemButtonClasses,
} from '@mui/material/ListItemButton';
import { alpha } from '@mui/material/styles';

import { styled } from '../styled/styled';

/**
 * @deprecated Please use `List.ItemButton` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type { ListItemButtonProps };
/**
 * @deprecated Please use `List.ItemButton` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItemButton = styled(MuiListItemButton)(({ color, theme }) => {
  if (color !== 'forceWhite') {
    return;
  }
  return {
    '&:active': {
      backgroundColor: alpha(
        theme.palette.forceWhite.main,
        theme.palette.action.selectedOpacity
      ),
    },
    '@media (hover: hover)': {
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.forceWhite.main,
          theme.palette.action.hoverOpacity
        ),
      },
    },
    [`&.${listItemButtonClasses.selected}`]: {
      backgroundColor: alpha(
        theme.palette.forceWhite.main,
        theme.palette.action.selectedOpacity
      ),
    },
    color: theme.palette.forceWhite.main,
  };
}) as typeof MuiListItemButton; // solving generic loss when using styled function: https://stackoverflow.com/a/72163115
